import script from "./AboutTurtles.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutTurtles.vue?vue&type=script&setup=true&lang=js"

import "./AboutTurtles.vue?vue&type=style&index=0&id=5791d50b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5791d50b"]])

export default __exports__